export default __webpack_public_path__ + "static/02_Ox-200d215764722857517b9df84b8e9949.png";